__turbopack_context__.v({
  "box": "IIOZrW_box" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "boxHasValue": "IIOZrW_boxHasValue",
  "chevronDownWrapper": "IIOZrW_chevronDownWrapper",
  "content": "IIOZrW_content",
  "root": "IIOZrW_root",
  "rootDisabled": "IIOZrW_rootDisabled",
});
